// src/utils/eventTypes.js
// Libellé de chaque `event_type` tel que l'écrit le serveur. Partagé par la liste
// d'événements et par le filtre « Type » de la recherche : un type nommé ici l'est partout.
export const EVENT_TYPE_LABELS = {
  alarm:          'Alarme',
  alarm_input:    'Entrée filaire',
  alarm_other:    'Alarme (commande inconnue)',
  tamper:         'Sabotage détecté',
  wired_fault:    'Défaut de l\'entrée filaire',
  arm_zone_open:  'Armement, zone ouverte',
  state:          'Armement / désarmement',
  power:          'Alimentation',
  battery:        'Batterie',
  low_battery:    'Batterie faible',
  rf_low_battery: 'Pile faible d\'un accessoire',
  accessory:      'Accessoire radio',
  offline:        'Hors ligne',
  online:         'En ligne',
  alert:          'Alerte',
  // Les heartbeats n'arrivent jamais dans la recherche ; un `status` qui s'y trouve est un
  // avertissement de santé émis par le serveur.
  status:         'Rapport de la carte',
  maintenance:    'Fenêtre de maintenance',
  config:         'Configuration',
  admin:          'Commande d\'administration',
  gnss:           'Position GPS',
  diag:           'Diagnostic radio',
  // Types historiques, absents de la base actuelle (voir EventList).
  state_change:   'Changement d\'état',
  power_change:   'Événement alimentation',
  config_update:  'Configuration mise à jour'
};

export const eventTypeLabel = type => EVENT_TYPE_LABELS[type] || 'Événement';
